import { Icons, Modal, Space, Typography } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'

type PendingWarehouseNoteModalProps = {
  modalProps: any
  close: () => void
  warehouseNote: string
}

export const PendingWarehouseNoteModal: React.FC<PendingWarehouseNoteModalProps> = ({
  modalProps,
  close,
  warehouseNote
}) => {
  const t = useTranslate()
  return (
    <Modal
      {...modalProps}
      title={null}
      centered
      closable
      footer={null}
      onCancel={close}
      style={{ zIndex: 800 }}
    >
      <Space direction='vertical' style={{ width: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div
            style={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: '#f6ffed',
              border: '1px solid #b7eb8f',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0
            }}
          >
            <Icons.ExclamationCircleOutlined style={{ fontSize: 18, color: '#52c41a' }} />
          </div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {t('common.advise')}
          </Typography.Title>
        </div>
        <div style={{ paddingLeft: 52 }}>
          <Typography.Text style={{ display: 'block' }}>
            {`${t('common.pendingNotes')}:`}
          </Typography.Text>
          <Typography.Text style={{ display: 'block', marginTop: 8 }}>
            {warehouseNote}
          </Typography.Text>
        </div>
      </Space>
    </Modal>
  )
}
